<template>
    <div v-cloak>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Visualizar Questão</b>

                        <i class="fa fa-list-alt" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
            </div>
            <div class="panel-body">
                <div class="row" style="margin-top:-25px;">
                    <form id="form">
                        <div class="col-md-8">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <span class="block"><b>Descrição da Questão:</b> {{ question.description }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 m-t-sm">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Pontuação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="question.answers.length" v-for="(answer, index) in question.answers">
                                        <td>{{ answer.description }}</td>
                                        <td>{{ answer.points }}</td>
                                    </tr>
                                    <tr v-if="!question.answers.length">
                                        <td colspan="2">Nenhuma resposta adicionada</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="col-md-12">
                            <div class="block text-right">
                                <router-link to="/question" class="btn btn-info m-r-sm">
                                    <i class="fa fa-arrow-left"></i> Voltar
                                </router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                question: {
                    description: '',
                    answers: []
                },
                aux: {
                    description: '',
                    points: ''
                }
            }
        },
        methods: {
            getQuestion: function() {
                const self = this;
                const api  = self.$store.state.api + 'question/' + self.$route.params.id + '?with[]=answers';

                self.$http
                    .get(api)
                    .then((response) => {
                        self.question = response.data.data[0];
                    })
                    .catch((error) => {
                        self.$message(null, 'Não foi possível buscar as informações da questão.', 'error');
                    });
            }
        },
        mounted: function () {
            this.getQuestion();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Question/View.vue